import * as registerActivitiesActions from '../../Project/RegisterActivities/actions';
import * as weekOverviewActions from '../../Project/WeekOverview/actions';
import update from 'react/lib/update';
import { spinnerStates } from '../../Globals/constants';

export const initState = {
  state: spinnerStates.SUCCESS
}

export default function(state = initState, action) {
  switch (action.type) {
    case registerActivitiesActions.GET_ACTIVITY_REQUEST:
    case registerActivitiesActions.SUBMIT_ACTIVITIES_REQUEST:
    case registerActivitiesActions.ADD_ACTIVITY_REQUEST:
    case registerActivitiesActions.ADD_SUB_ACTIVITY_REQUEST:
    case registerActivitiesActions.RENAME_ACTIVITIES_REQUEST:
    case registerActivitiesActions.UPDATE_POOL_REQUEST:
    case weekOverviewActions.SUBMIT_PERCENT_REQUEST:
    case weekOverviewActions.FETCH_WEEKLY_REQUEST:
      return update(state, {
        state: {
          $set: spinnerStates.LOADING
        }
      });
    case registerActivitiesActions.GET_ACTIVITY_SUCCESS:
    case registerActivitiesActions.SUBMIT_ACTIVITIES_SUCCESS:
    case registerActivitiesActions.ADD_ACTIVITY_SUCCESS:
    case registerActivitiesActions.ADD_SUB_ACTIVITY_SUCCESS:
    case registerActivitiesActions.RENAME_ACTIVITIES_SUCCESS:
    case registerActivitiesActions.UPDATE_POOL_SUCCCESS:
    case weekOverviewActions.SUBMIT_PERCENT_SUCCESS:
    case weekOverviewActions.FETCH_WEEKLY_SUCCESS:
      return update(state, {
        state: {
          $set: spinnerStates.SUCCESS
        }
      });
    case registerActivitiesActions.SUBMIT_ACTIVITIES_FAILURE:
    case registerActivitiesActions.ADD_ACTIVITY_FAILURE:
    case registerActivitiesActions.ADD_SUB_ACTIVITY_FAILURE:
    case registerActivitiesActions.RENAME_ACTIVITIES_FAILURE:
    case registerActivitiesActions.UPDATE_POOL_FAILURE:
    case weekOverviewActions.SUBMIT_PERCENT_FAILURE:
      return update(state, {
        state: {
          $set: spinnerStates.FAILURE
        }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Common/SmartSpinner/reducer.js